import { z } from "zod";

export const raw16Schema = z.string().regex(/^[0-9a-f]{32}$/u);

const timestampSchema = z.string().datetime({ offset: true });

export const checkoutRunStatusSchema = z.enum(["SCHEDULED", "IN_PROGRESS", "COMPLETED", "CLOSED"]);
export const cleaningJobStatusSchema = z.enum([
  "DRAFT",
  "OPEN",
  "OFFERED",
  "BOOKED",
  "IN_PROGRESS",
  "COMPLETED",
  "CANCELLED",
]);
export const linenOrderStatusSchema = z.enum([
  "CREATED",
  "DISPATCHED",
  "ACCEPTED",
  "PICKUP_CONFIRMED",
  "DELIVERED",
  "QC_COMPLETE",
  "CLOSED",
  "DECLINED",
  "CANCELLED",
]);

export const checkoutRunSchema = z.strictObject({
  checkoutRunId: raw16Schema,
  propertyId: raw16Schema,
  checkoutAt: timestampSchema,
  status: checkoutRunStatusSchema,
  createdAt: timestampSchema,
  derivedJobId: raw16Schema.nullable(),
  jobNumber: z.string().nullable(),
  jobStatus: cleaningJobStatusSchema.nullable(),
  acceptedCleanerName: z.string().nullable(),
  linenStatus: linenOrderStatusSchema.nullable(),
});

export const checkoutRunListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  checkoutRuns: z.array(checkoutRunSchema),
});

export type CheckoutRun = z.infer<typeof checkoutRunSchema>;
export type CheckoutRunStatus = z.infer<typeof checkoutRunStatusSchema>;
export type LinenOrderStatus = z.infer<typeof linenOrderStatusSchema>;
